import { z } from "zod";
import { hasDisallowedPayeeLabelChars, normalizePayeeLabelInput } from "@goppy/domain";

/**
 * 🔴 NAME-SANITIZE-PAYEE-FIELDS (QĐ điều phối 04/10 phương án (c), @UC0030 @UC0055) — ô NHÃN NGƯỜI/ĐƠN VỊ NHẬN TIỀN gõ tay: tên chủ tài khoản
 * (`accountName` — đọc ngay cạnh hành động chuyển tiền), người nhận (`payeeName`), đối tác đặt cọc (`counterparty`). Luật một nguồn ở
 * `@goppy/domain` `person-name.ts` (`normalizePayeeLabelInput` + `hasDisallowedPayeeLabelChars`): gộp khoảng trắng, CHẶN điều khiển / ngắt dòng /
 * định dạng-hướng / vô hình ⇒ 400 `VALIDATION_FAILED {field, reason: "format"}`. KHÔNG allowlist tên người (tên TK doanh nghiệp có `& . , /`).
 */
export const PAYEE_LABEL_INVALID_CHARS_MESSAGE =
  "Tên không được chứa xuống dòng, ký tự điều khiển, ký tự định hướng hay ký tự vô hình";

/**
 * Ô nhãn người nhận tiền: chuẩn hoá (gộp khoảng trắng) ⇒ `.trim()` ⇒ ràng buộc độ dài của ô (`constrain`) ⇒ chốt ký tự. Thứ tự lỗi giữ như
 * các ô tên khác: rỗng → quá dài → ký tự. Chuỗi KIỂM = chuỗi LƯU.
 */
export function payeeLabelSchema(constrain: (s: z.ZodString) => z.ZodString) {
  return z.preprocess(
    normalizePayeeLabelInput,
    constrain(z.string().trim()).refine((label) => !hasDisallowedPayeeLabelChars(label), PAYEE_LABEL_INVALID_CHARS_MESSAGE),
  );
}
